export const dateFormat = (dateStr: string | undefined) => {
  if (dateStr) {
    const date = new Date(dateStr);

    // padStart를 사용해서 두 자리 수 보장
    const formatted = `${date.getFullYear()}.${(date.getMonth() + 1)
      .toString()
      .padStart(2, '0')}.${date.getDate().toString().padStart(2, '0')}`;

    return formatted;
  } else {
    return '';
  }
};

export const dateFormatKor = (dateStr: string | undefined) => {
  if (dateStr) {
    const date = new Date(dateStr);

    // padStart를 사용해서 두 자리 수 보장
    const formatted = `${date.getFullYear()}년 ${(date.getMonth() + 1)
      .toString()
      .padStart(2, '0')}월 ${date.getDate().toString().padStart(2, '0')}일`;

    return formatted;
  } else {
    return '';
  }
};

export const timeFormat = (dateStr: string | undefined) => {
  if (dateStr) {
    const date = new Date(dateStr);

    const formatted = `${date.getHours().toString().padStart(2, '0')}:${date.getMinutes().toString().padStart(2, '0')}:${date.getSeconds().toString().padStart(2, '0')}`;

    return formatted;
  } else {
    return '';
  }
};

export function toNumber(value: string, defaultValue: number = 0): number {
  const num = Number(value);
  return isNaN(num) ? defaultValue : num;
}

export const payoutTypes = [
  { key: '-1', label: '보상 유형 선택' },
  { key: '0', label: '댁내 화재보상' },
  { key: '1', label: '댁내 도난보상' },
  // { key: '2', label: '택배 도난보상' },
  // { key: '3', label: '기기 도난보상' },
];

export function getPayoutTypeName(value: string): string {
  const found = payoutTypes.find((item) => item.key === value);
  return found?.label ?? payoutTypes[0].label;
}

export const payoutStatus = [
  { key: '0', label: '보상 청구 완료' },
  { key: '1', label: '보상 청구 취소' },
  { key: '2', label: '보상 지급 완료' },
  { key: '3', label: '담당자 지정 완료' },
];

export function getPayoutStatusName(value: string): string {
  const found = payoutStatus.find((item) => item.key === value);
  return found?.label ?? payoutStatus[0].label;
}

export function formatPhoneNumber(phone: string): string {
  const cleaned = phone.replace(/\D/g, ''); // 숫자만 남김

  // 02 지역번호 (서울): 9자리 or 10자리
  if (cleaned.startsWith('02')) {
    if (cleaned.length === 9) {
      return cleaned.replace(/(\d{2})(\d{3})(\d{4})/, '$1-$2-$3');
    } else if (cleaned.length === 10) {
      return cleaned.replace(/(\d{2})(\d{4})(\d{4})/, '$1-$2-$3');
    }
  }

  // 휴대폰 또는 다른 지역번호 (010, 031 등): 10자리 or 11자리
  if (cleaned.length === 10) {
    return cleaned.replace(/(\d{3})(\d{3})(\d{4})/, '$1-$2-$3');
  } else if (cleaned.length === 11) {
    return cleaned.replace(/(\d{3})(\d{4})(\d{4})/, '$1-$2-$3');
  }
  
  const len = cleaned.length;
  if (len < 4) return cleaned;
  if (len < 8) return cleaned.replace(/(\d{3})(\d+)/, '$1-$2');
  return cleaned.replace(/(\d{3})(\d{4})(\d+)/, '$1-$2-$3');
}

export function formatAndMaskPhoneNumber(phone: string): string {
  const cleaned = phone.replace(/\D/g, ''); // 숫자만 남김

  // 1. 서울 지역번호 (02) 처리
  if (cleaned.startsWith('02')) {
    if (cleaned.length === 9) {
      // 02-XXX-XXXX -> 02-***-XXXX
      return cleaned.replace(/(\d{2})(\d{3})(\d{4})/, (match, p1, p2, p3) => `${p1}-***-${p3}`);
    } else if (cleaned.length === 10) {
      // 02-XXXX-XXXX -> 02-****-XXXX
      return cleaned.replace(/(\d{2})(\d{4})(\d{4})/, (match, p1, p2, p3) => `${p1}-****-${p3}`);
    }
  }

  // 2. 휴대폰 및 기타 지역번호 (010, 031 등) 처리
  if (cleaned.length === 10) {
    // 010-XXX-XXXX -> 010-***-XXXX
    return cleaned.replace(/(\d{3})(\d{3})(\d{4})/, (match, p1, p2, p3) => `${p1}-***-${p3}`);
  } else if (cleaned.length === 11) {
    // 010-XXXX-XXXX -> 010-****-XXXX
    return cleaned.replace(/(\d{3})(\d{4})(\d{4})/, (match, p1, p2, p3) => `${p1}-****-${p3}`);
  }

  // 형식에 맞지 않는 경우 원본 반환
  return phone;
}

export function isCompleteHangul(text: string): boolean {
  // 1. 공백이나 특수문자 등을 제외하고 '한글'만 필터링하고 싶다면 정규식을 조정하세요.
  // 아래 정규식은 "오직 완성된 한글"로만 이루어져 있는지 확인합니다.
  const completeHangulRegex = /^[가-힣]+$/;

  return completeHangulRegex.test(text);
}

export function ownerCheck(): boolean {
  const isOwner = sessionStorage.getItem('isOwner');

  return isOwner === 'true';
}

export function validatePhoneNumber(val: string): boolean {
  if (!val) return false;

  const cleaned = val.replace(/\D/g, ''); // 숫자만 남김

  // 1. 서울 (02): 9~10자리
  if (cleaned.startsWith('02')) {
    return cleaned.length >= 9 && cleaned.length <= 10;
  }
  
  // 2. 휴대폰 및 기타 지역번호 (010, 031 등): 10~11자리
  if (cleaned.startsWith('0')) {
    return cleaned.length >= 10 && cleaned.length <= 11;
  }

  return false;
};


export function validateName(value: string): boolean {
  if (value.length === 0) {
    return false;
  }
  if (value.length > 0 && !/^[a-zA-Z\s가-힣]+$/.test(value)) {
    return false;
  }
  return true;
};